import React from "react"
import { Link } from "react-router-dom"
import removeMd from "remove-markdown"
import TweenLite, { Power2 } from "gsap/umd/TweenMax"

// Components
import "./style.css"

const EraPreviewBox = ({ title, description, image, link, year, yearTo, filter}) => {
    const text = removeMd(description) // Fjerner markdown markup
    const textSplit = text.split(" ").slice(0, 20) // Henter et utdrag
    const descriptionPreview = textSplit.join(" ")

    const fadeInImage = (event) => {
        TweenLite.to(event.target, 0.3, { opacity: 1, ease: Power2.easeIn })
    }

    return (
        <div className="era-link-wrapper">
            <div className="era-preview-box highlighted-box">
                { year && <Link to={yearTo} className={`era-preview-box__year button button--purple ${!filter ? "era-preview-box__year--disabled" : ""}`}><small>{ year }</small></Link> }
                <Link to={link} className="era-image-box">
                    <img
                        className="img-res era-image-box__image"
                        src={image}
                        alt={title}
                        style={{ opacity: 0 }}
                        ref={comp => { this.image = comp }}
                        onLoad={fadeInImage} />
                </Link>

                <Link to={link} className="era-preview-box-text-wrapper">
                    <h4 className="era-preview-box-text-wrapper__title">{ title }</h4>
                    <p className="era-preview-box-text-wrapper__text">{ descriptionPreview }...</p>
                </Link>

            </div>
        </div>
    )
}

export default EraPreviewBox



// WEBPACK FOOTER //
// ./src/components/EraPreviewBox/index.js